<ng-template #searchUserPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSearchUserPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{!isSwitchingUser ? 'Search ' : 'Switch '}} {{popupTitle}} User</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="search-popup">
        <div class="row" [hidden]="changeInCriteria">
            <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedUserCriteria">
                <mat-radio-button class="tp-radio-button" color="primary" *ngFor="let criteria of searchCriteriaOptions"
                    [value]="criteria" (change)="onSearchCriteriaChanged(criteria)">
                    {{criteria}}
                </mat-radio-button>
            </mat-radio-group>
        </div><br />

        <div class="row">
            <div class="col-md-4">
                <div><label for="email">User Name</label></div>
                <input *ngIf="selectedUserCriteria == 'All Quality Users'" class="search-filed-continers" type="text"
                    [(ngModel)]="searchByUserName">
                <mat-select *ngIf="selectedUserCriteria != 'All Quality Users' && selectionMode == 'single'" matInput
                    placeholder="Select" [(ngModel)]="selectedGroupUser" (closed)="groupUserSearchText=''"
                    (click)="focusSearch('focus-group-user-search')"
                    (keydown.enter)="focusSearch('focus-group-user-search')">
                    <input type="search" id="focus-group-user-search" class="dropdownsearchstyle"
                        [(ngModel)]="groupUserSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle"
                        (onSelectionChange)="onGroupUserSelect($event, null)">Un-select</mat-option>
                    <mat-option *ngFor="let item of groupUsersDropdown | assessmentSearch : groupUserSearchText"
                        [value]="item.valueExp" (selectionChange)="onGroupUserSelect($event, item)"
                        (onSelectionChange)="onGroupUserSelect($event, item)">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
                <mat-select *ngIf="selectedUserCriteria != 'All Quality Users' && selectionMode == 'multiple'" matInput
                    multiple placeholder="Select" #multi [(ngModel)]="tempMultiUsersArray"
                    [matTooltip]="selectedGroupUser" (closed)="groupUserSearchText = ''"
                    (click)="focusSearch('focus-b-area-search')" (keydown.enter)="focusSearch('focus-b-area-search')">
                    <input type="search" id="focus-b-area-search" class="dropdownsearchstyle"
                        [(ngModel)]="groupUserSearchText" matInput placeholder="search">
                    <div class="select-all">
                        <mat-checkbox [(ngModel)]="isAllUserSelected" (change)="toggleAllSelection('multi')">Select
                            All</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let item1 of groupUsersDropdown| multiAssessmentSearchPipe :groupUserSearchText"
                        [value]="item1.valueExp" (selectionChange)="onMultiGroupUserSelect($event,item1)"
                        (onSelectionChange)="onMultiGroupUserSelect($event, item1)">
                        {{ item1.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Quality Users'">
                <div><label for="email">First Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Quality Users'">
                <div><label for="email">Last Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Quality Users'">
                <div><label for="email">Email</label></div>
                <input class="search-filed-continers" type="email" [(ngModel)]="searchByEmail">
                <div id="email-val-icon" class="field-icon-container"></div>
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Quality Users'">
                <div><label for="email">Designation</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
                    (closed)="designationSearchText=''" (click)="focusSearch('focus-designation-search')"
                    (keydown.enter)="focusSearch('focus-designation-search')">
                    <input type="search" id="focus-designation-search" class="dropdownsearchstyle"
                        [(ngModel)]="designationSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
                    <mat-option *ngFor="let item of designationDropdown | assessmentSearch : designationSearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Quality Users'">
                <div><label for="email">Department</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
                    (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
                    (keydown.enter)="focusSearch('focus-department-search')">
                    <input type=" search" id="focus-department-search" class="dropdownsearchstyle"
                        [(ngModel)]="departmentSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
                    <mat-option *ngFor="let item of departmentDropdown | assessmentSearch : departmentSearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="row">
            <div class="button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="addButton" (click)="searchUser()"
                    [ngStyle]="selectedUserCriteria != 'All Quality Users' && (selectionMode == 'single' ? !selectedGroupUser : !tempMultiUsersArray.length) ? {'cursor': 'not-allowed'} : {}"
                    [disabled]="selectedUserCriteria != 'All Quality Users' && (selectionMode == 'single' ? !selectedGroupUser : !tempMultiUsersArray.length)">
                    <i class="fa-solid fa-magnifying-glass" *ngIf="selectedUserCriteria == 'All Quality Users'"></i>
                    <i class="fas fa-check" *ngIf="selectedUserCriteria != 'All Quality Users'"></i>
                    {{selectedUserCriteria == 'All Quality Users' ?'Search':'Pick'}}
                </button>
                <button mat-stroked-button class="cancelButton" *ngIf="!listOfUsers.length"
                    (click)="cancelSearchUserPopup()">
                    <i class="fa fa-close"></i> Cancel
                </button>
                <button mat-stroked-button class="cancelButton"
                    *ngIf="searchByUserName || searchByFirstName || searchByLastName || searchByEmail || searchByDesignationCode || searchByDepartmentCode || listOfUsers.length || selectedGroupUser"
                    (click)="reset()">
                    <i class="fas fa-undo"></i> Reset
                </button>
            </div>
        </div>
        <div class="table-container" *ngIf="listOfUsers.length">
            <table style="max-height: 45vh;">
                <thead>
                    <th style="min-width: 60px; text-align: center;">
                        <div style="display: flex;">
                            <div>
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                            <div style="margin-left: 5px;" *ngIf="selectionMode == 'multiple'">
                                <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="searchUserParentCheckBox"
                                    (change)="onParentCheckBoxChanged($event)">
                            </div>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>User Name</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>First Name</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Last Name</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Email</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Designation</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Department</span>
                        </div>
                    </th>

                    <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let user of listOfUsers; let idx = index;">
                        <td style="min-width: 80px; text-align: center;">
                            <div style="display: flex;">
                                <div [ngClass]="user.searchUserChildCheckBox ?'static_icon':'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div style="margin-left: 5px;">
                                    <input id="selectedUserCheckBox`" type="checkbox" style="zoom: 1.2;"
                                        [checked]="user.searchUserChildCheckBox"
                                        (change)="selectionMode == 'multiple' ? onChildCheckBoxChanged($event, user, idx) : onChecked($event, user)">
                                </div>
                            </div>
                        </td>
                        <td class="row-data">{{ user.userName }}</td>
                        <td class="row-data">{{ user.firstName }}</td>
                        <td class="row-data">{{ user.lastName }}</td>
                        <td class="row-data">{{ user.emailAddress }}</td>
                        <td class="row-data">{{ user.designation }}</td>
                        <td class="row-data">{{ user.department }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions *ngIf="listOfUsers.length">
            <button mat-stroked-button class="addButton" (click)="selectUser()"
                [ngStyle]="isAddDisabled ? { cursor: 'not-allowed' } : {}" [disabled]="isAddDisabled">
                <i class="fas fa-check"></i> Add
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelSearchUserPopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #reasonPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeReasonPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Reason for Switch </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px;" class="col-md-11">
        <div>
            <label id="switch-reason-validation" for="email">Reason
                <span class="mandatory-symbol">*</span>
            </label>
        </div>
        <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="switchUserComponent.reasonForSwitch"
            (ngModelChange)="mandatoryValidation($event,'switch-reason-validation')"></textarea>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions style="margin-top: 2%;">
        <button mat-stroked-button class="addButton" (click)="openConfirmationPopup()">
            <i class="fa fa-check"></i> Yes
        </button>
        <button mat-stroked-button class="cancelButton" (click)="closeReasonPopup()">
            <i class="fas fa-close"></i> No
        </button>
    </div>
</ng-template>

<ng-template #confirmationPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeConfirmationPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Confirmation </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="center">
        <label for="email" style="font-size: medium; font-weight: bold;">
            Do you want to Switch {{popupTitle}}?</label>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions style="margin-top: 2%;">
        <button mat-stroked-button class="addButton" (click)="triggerEmit()">
            <i class="fa fa-check"></i> Yes
        </button>
        <button mat-stroked-button class="cancelButton" (click)="closeConfirmationPopup()">
            <i class="fas fa-close"></i> No
        </button>
    </div>
</ng-template>